export const permis125PermisBData = {
  path: '/125-permis-b',
  breadcrumb: [
    ['Formations 2 & 3 roues', '/formation'],
    ['125 avec permis B', '/125-permis-b'],
  ],
  kicker: 'Formation 7h · permis B + 2 ans',
  title: '125 avec permis B',
  titleHighlight: 'la formation 7 heures.',
  subtitle:
    "Tu as le permis B depuis 2 ans ? Une formation de 7 heures te permet de conduire un scooter ou une moto 125 cm³, sans repasser de Code ni d'examen.",
  seoTitle: '125 avec permis B — Formation 7h obligatoire • Scooter & moto 125 cm³',
  seoDescription:
    "Conduire un 125 cm³ avec le permis B : formation 7h obligatoire (depuis 2011), conditions, prix, déroulement, conseils ECSR. Pour scooter ou moto 125 cm³ ≤ 11 kW.",
  seoKeywords:
    '125 permis b, scooter 125 permis b, formation 7h moto, formation 125 permis b, equivalence permis b 125, scooter avec permis b, moto 125 sans permis a',
  heroImage:
    'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=2400&q=85&auto=format&fit=crop',
  heroImageAlt: 'Scooter 125 conduit avec permis B',
  duration: '7 heures (1 journée)',
  cost: '~ 230 à 350 €',
  timeRequired: 'PT7H',
  about: 'Permis B, formation 7h, scooter 125, moto 125',
  primaryCta: { label: 'Voir les formations', to: '/formation' },
  secondaryCta: { label: 'Équipement obligatoire', to: '/equipement-moto-obligatoire' },
  relatedTopic: '125',
  accentColor: '#0891b2',

  intro:
    "<p>Tu as le <strong>permis B depuis au moins 2 ans</strong> ? Tu peux conduire un <strong>scooter ou une moto 125 cm³</strong> (jusqu'à 11 kW / 15 ch) en suivant une <strong>formation pratique de 7 heures</strong> en moto-école agréée.</p><p>Cette formation est <strong>obligatoire depuis le 1er janvier 2011</strong>. Sans elle, même avec un permis B en poche, tu n'as pas le droit de conduire un 125. Pas d'examen final, juste l'évaluation continue du moniteur. Attestation valide à vie en France et UE.</p>",

  conditions: [
    {
      title: 'Permis B depuis 2 ans',
      text: "2 ans pleins de permis B à la date de la formation. Si tu as eu ton permis B le 10 juin 2023, tu peux faire la 7h dès le 10 juin 2025.",
    },
    {
      title: 'Pas d\'équivalence automatique',
      text: "Si tu as obtenu ton permis B avant le 1er janvier 1980 ou ton permis A1 (cyclo) avant le 1er janvier 2011, l'équivalence est automatique : pas besoin de la 7h.",
    },
    {
      title: 'En moto-école agréée',
      text: 'Seules les moto-écoles avec agrément préfectoral peuvent dispenser cette formation. Vérifie l\'attestation de formateur du moniteur.',
    },
    {
      title: 'Équipement obligatoire',
      text: 'Casque homologué, gants CE, blouson, pantalon long, chaussures montantes. Sans équipement complet, la moto-école peut refuser la formation.',
    },
  ],

  steps: [
    {
      title: 'Module théorique (2h)',
      duration: '2 heures',
      text: 'Spécificités du 2-roues : vulnérabilité, angles morts, vu / non vu, freinage différent, équipement obligatoire, statistiques accidentologie. Pour la plupart des conducteurs B, c\'est une vraie découverte.',
    },
    {
      title: 'Module maniabilité hors circulation (2h)',
      duration: '2 heures',
      text: 'Sur piste fermée : prise en main du scooter ou de la moto 125, allure lente, freinage, slalom, demi-tour. Pour beaucoup, c\'est la 1ʳᵉ fois sur 2-roues motorisé.',
    },
    {
      title: 'Module circulation (3h)',
      duration: '3 heures',
      text: 'Conduite en conditions réelles : ville, hors agglomération. Apprentissage du regard, des trajectoires de sécurité, des intersections, du contrôle angle mort.',
    },
    {
      title: 'Délivrance attestation',
      duration: '15 minutes',
      text: 'Le moniteur valide la formation. Tu reçois une attestation \"Formation 7h\" à conserver à vie. Pas d\'examen, pas de mise à jour du permis (l\'attestation suffit en cas de contrôle).',
    },
  ],

  erreurs: [
    {
      title: 'Croire qu\'on peut s\'en passer',
      text: 'Conduire un 125 sans la 7h = 750 € d\'amende, immobilisation du véhicule, et annulation de l\'assurance en cas d\'accident.',
    },
    {
      title: 'Choisir une moto trop puissante',
      text: 'La 7h donne accès aux 125 cm³ jusqu\'à 11 kW (15 ch). Une 125 \"performances\" à 13-15 ch reste OK ; au-delà, il te faut le permis A1 ou A2.',
    },
    {
      title: 'Oublier l\'équipement obligatoire',
      text: 'Casque + gants CE OBLIGATOIRES même sur scooter 125. Pas de gants = 68 € d\'amende + 1 point.',
    },
    {
      title: 'Sous-estimer la prise en main',
      text: 'Un scooter 125 se manie différemment d\'une voiture : freinage avant prioritaire, regard très loin, trajectoires anticipées. La 7h est là pour ça.',
    },
  ],

  conseils: [
    'Avant la formation, regarde quelques vidéos YouTube de prise en main scooter 125 : tu seras moins surpris.',
    'Si tu hésites entre scooter et moto 125 : demande à essayer les deux pendant la formation. Ton ressenti décidera.',
    'Investis dans un équipement de qualité (casque ECE 22-06, gants CE) : ta sécurité dépend principalement de ça.',
    'Conserve ton attestation 7h dans la moto / scooter — obligatoire en cas de contrôle.',
    'Après 6 mois de 125 : envisage le permis A1 ou A2 pour passer à plus puissant en sécurité.',
  ],

  faq: [
    {
      q: 'Qui doit faire la formation 7h pour conduire un 125 ?',
      a: 'Tous les titulaires du permis B obtenu après le 1er janvier 1980, qui n\'ont pas conduit de 2-roues motorisé dans les 5 ans précédents. À partir du 1er janvier 2011, la formation est strictement obligatoire pour tous (sauf cas d\'équivalence).',
    },
    {
      q: 'Combien coûte la formation 7h pour 125 ?',
      a: 'Entre 230 et 350 € selon les régions. Le tarif inclut le scooter ou la moto, le carburant, les 7 heures de formation, et la délivrance de l\'attestation. Aucun frais d\'examen (il n\'y a pas d\'examen).',
    },
    {
      q: 'L\'attestation 7h est-elle valable à vie ?',
      a: 'Oui, sans limite de durée en France. Elle reste valide tant que ton permis B reste valable. Même si tu arrêtes de conduire un 125 pendant 10 ans, ton attestation reste bonne quand tu reprends.',
    },
    {
      q: 'Peut-on conduire une moto 125 ou seulement un scooter avec la 7h ?',
      a: 'Les deux ! La formation 7h donne accès à tous les véhicules de catégorie L3e (motos) et L1e (scooters) jusqu\'à 125 cm³ et 11 kW. Tu peux donc choisir une CB125R, une YBR125, un SH125, un PCX125, etc.',
    },
    {
      q: 'Y a-t-il un examen à la fin de la formation 7h ?',
      a: 'NON. C\'est une formation, pas un examen. Le moniteur évalue tes compétences en continu sur les 7 heures. Si tu suis correctement, tu obtiens automatiquement ton attestation. Échec extrêmement rare.',
    },
    {
      q: 'La formation 7h est-elle valable à l\'étranger ?',
      a: 'Dans l\'UE : oui, ton permis B avec attestation 7h est reconnu dans tous les pays membres. Hors UE : à vérifier au cas par cas, parfois un permis A1 international est exigé.',
    },
  ],

  sourceLabel:
    'Décret 2010-1580 du 17 décembre 2010, arrêté du 8 novembre 2012, Sécurité routière.',
  sourceUrl: 'https://www.service-public.fr/particuliers/vosdroits/F2814',
};
